import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './Navigation.css'

const NAV_ITEMS = [
  { id: 'hero',       label: 'Accueil',      icon: '⬡' },
  { id: 'about',      label: 'À propos',     icon: '◉' },
  { id: 'skills',     label: 'Compétences',  icon: '◈' },
  { id: 'projects',   label: 'Projets',      icon: '◎' },
  { id: 'experience', label: 'Parcours',     icon: '◇' },
  { id: 'lab',        label: 'Lab 3D',       icon: '✦' },
  { id: 'data-ia',    label: 'Data & IA',    icon: '◎' },
  { id: 'analyse-data', label: 'Analyse Data',  icon: '📊' },
  { id: 'contact',    label: 'Contact',      icon: '◑' },
]

export default function Navigation({ activeSection, scrollY }) {
  const [menuOpen, setMenuOpen] = useState(false)
  const scrolled = scrollY > 40
  const location = useLocation()
  const isHomePage = location.pathname === '/'

  const scrollTo = (id) => {
    if (isHomePage) {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
    }
    setMenuOpen(false)
  }

  const navigateTo = (path) => {
    setMenuOpen(false)
  }

  return (
    <>
      <nav className={`nav ${scrolled ? 'scrolled' : ''}`} role="navigation" aria-label="Navigation principale">
        <div className="nav-inner">
          {/* Logo */}
          <Link to="/" className="nav-logo">
            <span className="logo-bracket">[</span>
            <span className="logo-name">QO</span>
            <span className="logo-bracket">]</span>
            <span className="logo-dot dot-pulse" />
          </Link>

          {/* Desktop links */}
          <ul className="nav-links">
            {NAV_ITEMS.map(item => {
              if (item.id === 'analyse-data') {
                return (
                  <li key={item.id}>
                    <Link
                      to={`/${item.id}`}
                      className="nav-link"
                      onClick={() => navigateTo(`/${item.id}`)}
                    >
                      {item.label}
                      <span className="nav-link-indicator" />
                    </Link>
                  </li>
                )
              }
              return (
                <li key={item.id}>
                  <button
                    className={`nav-link ${activeSection === item.id ? 'active' : ''}`}
                    onClick={() => scrollTo(item.id)}
                    aria-current={activeSection === item.id ? 'page' : undefined}
                  >
                    {item.label}
                    <span className="nav-link-indicator" />
                  </button>
                </li>
              )
            })}
          </ul>

          {/* CTA */}
          <a
            href="mailto:quentin.ott2511@gmail.com"
            className="nav-cta btn-primary"
          >
            Me contacter
          </a>

          {/* Burger */}
          <button
            className={`nav-burger ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
            aria-expanded={menuOpen}
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`} aria-hidden={!menuOpen}>
        <div className="mobile-menu-bg" onClick={() => setMenuOpen(false)} />
        <div className="mobile-menu-panel">
          <ul>
            {NAV_ITEMS.map((item, i) => {
              if (item.id === 'analyse-data') {
                return (
                  <li key={item.id} style={{ '--i': i }}>
                    <Link
                      to={`/${item.id}`}
                      className="mobile-link"
                      onClick={() => navigateTo(`/${item.id}`)}
                    >
                      <span className="mobile-link-icon">{item.icon}</span>
                      {item.label}
                    </Link>
                  </li>
                )
              }
              return (
                <li key={item.id} style={{ '--i': i }}>
                  <button
                    className={`mobile-link ${activeSection === item.id ? 'active' : ''}`}
                    onClick={() => scrollTo(item.id)}
                  >
                    <span className="mobile-link-icon">{item.icon}</span>
                    {item.label}
                  </button>
                </li>
              )
            })}
          </ul>
          <a href="mailto:quentin.ott2511@gmail.com" className="btn-primary mobile-cta">
            quentin.ott2511@gmail.com
          </a>
        </div>
      </div>
    </>
  )
}
